import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isConversationalTagsResult = objectOf({
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});
